var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admin-config-page" }, [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("configuration.server_configuration"))),
          ]),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "server" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c("div", { staticClass: "admin-config-panel__inner" }, [
            _c(
              "section",
              {
                staticClass: "admin-config-section",
                attrs: {
                  "aria-label": _vm.trans("configuration.server_configuration"),
                },
              },
              [
                _c("h4", { staticClass: "admin-config-section__title" }, [
                  _vm._v(
                    _vm._s(_vm.trans("configuration.server_configuration"))
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "admin-config-section__description" }, [
                  _vm._v(
                    _vm._s(_vm.trans("configuration.server_configuration_hint"))
                  ),
                ]),
                _vm._v(" "),
                _vm.configForm.server
                  ? _c(
                      "div",
                      { staticClass: "alert alert-light border mb-4" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "caption-text text-uppercase text-soft mb-2",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.trans("configuration.server_saved_summary")
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "list list-plain mb-0 small" },
                          [
                            _c("li", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("configuration.choose_server")
                                  ) + ":"
                                ),
                              ]),
                              _vm._v(" " + _vm._s(_vm.serverLabel)),
                            ]),
                            _vm._v(" "),
                            _vm.configForm.server === "cpanel"
                              ? [
                                  _c("li", [
                                    _c("strong", [_vm._v("cPanel Host:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.configForm.cpanel_host || "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("cPanel Port:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.configForm.cpanel_port || "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("cPanel Username:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.configForm.cpanel_username || "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("cPanel Password:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.cpanel_has_password
                                            ? "•••••••• (saved)"
                                            : "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "configuration.cpanel_api_token"
                                          )
                                        ) + ":"
                                      ),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.cpanel_has_api_token
                                            ? "•••••••• (saved)"
                                            : "—"
                                        )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.configForm.server === "plesk"
                              ? [
                                  _c("li", [
                                    _c("strong", [_vm._v("Plesk Host:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.configForm.plesk_host || "—")
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("Plesk Username:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.configForm.plesk_username || "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [
                                      _vm._v("Plesk Webspace Id:"),
                                    ]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.configForm.plesk_webspace_id ||
                                            "—"
                                        )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c("strong", [_vm._v("Plesk Password:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.plesk_has_password
                                            ? "•••••••• (saved)"
                                            : "—"
                                        )
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "mt-3",
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.submit.apply(null, arguments)
                      },
                      keydown: function ($event) {
                        return _vm.configForm.errors.clear($event.target.name)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", { attrs: { for: "" } }, [
                          _vm._v(
                            _vm._s(_vm.trans("configuration.choose_server"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.configForm.server,
                                expression: "configForm.server",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: { name: "server" },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.configForm,
                                    "server",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                                function ($event) {
                                  return _vm.configForm.errors.clear("server")
                                },
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.trans("general.select_one"))),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "local" } }, [
                              _vm._v("Local"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "cpanel" } }, [
                              _vm._v("cPanel"),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "plesk" } }, [
                              _vm._v("Plesk"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("show-error", {
                          attrs: {
                            "form-name": _vm.configForm,
                            "prop-name": "server",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.configForm.server === "cpanel"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("cPanel Host"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.cpanel_host,
                                    expression: "configForm.cpanel_host",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "cpanel_host",
                                  placeholder:
                                    "e.g. server.hostname.com or shared IP",
                                },
                                domProps: { value: _vm.configForm.cpanel_host },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "cpanel_host",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "cpanel_host",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("cPanel Port"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.cpanel_port,
                                    expression: "configForm.cpanel_port",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "cpanel_port",
                                  placeholder: "2083 (SSL) or 2082",
                                },
                                domProps: { value: _vm.configForm.cpanel_port },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "cpanel_port",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "cpanel_port",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("cPanel Username"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.cpanel_username,
                                    expression: "configForm.cpanel_username",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "cpanel_username",
                                  placeholder: "cPanel Username",
                                },
                                domProps: {
                                  value: _vm.configForm.cpanel_username,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "cpanel_username",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "cpanel_username",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("cPanel Password"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.cpanel_password,
                                    expression: "configForm.cpanel_password",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "password",
                                  autocomplete: "new-password",
                                  name: "cpanel_password",
                                  placeholder: "cPanel Password",
                                },
                                domProps: {
                                  value: _vm.configForm.cpanel_password,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "cpanel_password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.cpanel_has_password
                                ? _c(
                                    "small",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "configuration.password_unchanged_hint"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "cpanel_password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("configuration.cpanel_api_token")
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.cpanel_api_token,
                                    expression: "configForm.cpanel_api_token",
                                  },
                                ],
                                staticClass: "form-control font-monospace",
                                attrs: {
                                  type: "password",
                                  autocomplete: "new-password",
                                  name: "cpanel_api_token",
                                  placeholder:
                                    "Paste API token from cPanel → Security → Manage API Tokens",
                                },
                                domProps: {
                                  value: _vm.configForm.cpanel_api_token,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "cpanel_api_token",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "form-text text-muted" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.trans(
                                        "configuration.cpanel_api_token_hint"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.cpanel_has_api_token
                                ? _c(
                                    "small",
                                    {
                                      staticClass:
                                        "form-text text-muted d-block",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "configuration.password_unchanged_hint"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "cpanel_api_token",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.configForm.server === "plesk"
                      ? _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Plesk Host"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.plesk_host,
                                    expression: "configForm.plesk_host",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "plesk_host",
                                  placeholder: "Plesk Host",
                                },
                                domProps: { value: _vm.configForm.plesk_host },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "plesk_host",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "plesk_host",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Plesk Username"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.plesk_username,
                                    expression: "configForm.plesk_username",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "plesk_username",
                                  placeholder: "Plesk Username",
                                },
                                domProps: {
                                  value: _vm.configForm.plesk_username,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "plesk_username",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "plesk_username",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Plesk Password"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.plesk_password,
                                    expression: "configForm.plesk_password",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "password",
                                  autocomplete: "new-password",
                                  name: "plesk_password",
                                  placeholder: "Plesk Password",
                                },
                                domProps: {
                                  value: _vm.configForm.plesk_password,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "plesk_password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _vm.plesk_has_password
                                ? _c(
                                    "small",
                                    { staticClass: "form-text text-muted" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.trans(
                                            "configuration.password_unchanged_hint"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "plesk_password",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v("Plesk Webspace Id"),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.configForm.plesk_webspace_id,
                                    expression: "configForm.plesk_webspace_id",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  name: "plesk_webspace_id",
                                  placeholder: "Plesk Webspace Id",
                                },
                                domProps: {
                                  value: _vm.configForm.plesk_webspace_id,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.configForm,
                                      "plesk_webspace_id",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.configForm,
                                  "prop-name": "plesk_webspace_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "admin-config-actions" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                          attrs: { type: "submit" },
                        },
                        [_vm._v(_vm._s(_vm.trans("general.save")))]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nk-block-des text-soft" }, [
      _c("p", [
        _vm._v(
          "Choose the provisioning backend and maintain saved hosting credentials."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }